import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import useLang from "@/Hooks/useLang";
import Text from "@/Components/Front/Text";

import {Link} from "@inertiajs/inertia-react";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import Header from "@/Components/Front/Header";

import ArrowBack from "@/Components/Front/SVGS/ArrowBack";

import LineaMeta from "@/Components/Front/SVGS/LineaMeta";
import MetaAnalysis from "@/Components/Front/SVGS/Services/MetaAnalysis";
import Gad from "@/Components/Front/PNGS/grad-ma.png";
import {useMediaQuery} from "react-responsive";

export default function ServicesDataScience(props) {

    const [lang, setLang] = useLang(props.locale);

    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isMobileAndTabletPortrait = useMediaQuery({query: '(max-width: 767px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isLg = useMediaQuery({query: '(min-width: 1024px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})
    const textProps = {
        lang: lang, language: props.language,
    };


    return (
        <AppLayout {...props}>
            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang} activeItem={"services-meta-analysis"}/>

            <section id="meta" className={"services-page"}>
                <div className={"back-arrow"}>
                </div>
                {isMobileAndTabletPortrait &&
                    <div className={"mobile-image"}>
                        <img src="images/Meta.png" alt=""/>

                    </div>
                }


                <div className="in-frame-inner">
                    {isMd &&
                        <>
                        {/*<div className={"section-gradient"}>*/}
                        {/*    <img src={Gad} alt=""/>*/}
                        {/*</div>*/}
                        <div className={"section-background"}>

                        <MetaAnalysis/>
                        </div>
                        </>
                    }

                    <div className={"section-title"}>
                        <div className={"service-icon"}>
                            <LineaMeta/>
                        </div>
                        <div className={"service-back-button"}>
                            <Link href={"/"}>
                                <ArrowBack/>
                            </Link>
                        </div>
                        <h1>
                            <span><Text {...textProps} str={"meta-title-1"}/></span>
                            <span><Text {...textProps} str={"meta-title-2"}/></span>
                        </h1>
                        <div className={"services-data-container"}>

                        <p>
                            <Text {...textProps} str={"meta-text-1"} html={true}/>
                        </p>
                        <p>
                            <Text {...textProps} str={"meta-text-2"} html={true}/>
                        </p>
                        </div>

                    </div>



                    <div className={"back-button"}>
                        <Link href={"/"}>

                            <button>
                                <ChevronRight/> <Text {...textProps} str={"back"}/>
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
        </AppLayout>

    )
}
